import React from 'react';
import LogoImage from "~images/loggedout/home/logo.png";
import LogoWhite from "~images/loggedout/home/logo-white.png";

import Image from '../common/Image';
import { Link } from 'react-router-dom';
import { HOME_PATH } from '../../../routes/route-paths';
import { trackToGtmFE } from '../../../utils/gtm-event-common';

const Logo = React.memo(({src, showWhiteLogo, routePath, noRedirection }) => {
  const windowReload = () => {
    if(window.location.pathname !== HOME_PATH) {
      setTimeout(function(){
        window.location.reload();
      },10);
    }
    trackToGtmFE('clicked_navigation',{'Click URL': window?.location?.pathname,'Click Text': 'logo'});
  };

  return (
    <Link to={noRedirection ? '#' : (routePath ? routePath : HOME_PATH)} 
      onClick={() => windowReload()}
    >
      <Image
        src={ src ? src : (showWhiteLogo ? LogoWhite : LogoImage)}
        alt="SplashLearn: Fun Math & ELA Learning Program for PreK-Grade 5"
        className="logo-splashlearn"
        width="100%"
        height="100%"
      />
    </Link>
  );
});

export default Logo;
